import { z } from "zod";

export const updateSnapshotTestSchema = z.object({
    snapshotId: z.string().min(1),
    testCaseId: z.string().min(1),
    expectedPlanId: z.string().min(1).optional(),
    plan: z.string().trim().min(1, "Enter the test prerequisites, steps, and expected results."),
    scenarioId: z.string().min(1).optional(),
});
